import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "./userSetup.actions";
import { dataUserSetupReducer } from "./userSetup.reducers";
import {
  formatArrayAccessUser,
  generateRoutes,
  sortMenuItemsByOrdem,
  verifyAllowedUserAccess,
} from "./utils";
import { IUserSetup } from "./models";

const initialState: IUserSetup = {
  userConfig: {
    routes: {
      menuItems: [],
      renderItems: [],
      allowedRoutes: {},
    },
    roles: {},
    views: {
      home: {},
      edi: {},
      matriz: {},
      comprovantes: {},
      configuracoes: {
        ocorrencias: {},
        variaveis: {},
        transportadoras: {},
        camposDaMatriz: {
          camposLista: [],
          tipoCampos: "",
          camposExportacao: [],
        },
      },
    },
    listaTransportadoras: [],
    isJuridico: false,
  },
};

const userSetupSlice = createSlice({
  name: "userSetup",
  initialState,
  reducers: {
    setUserConfig: (state, action) => {
      state.userConfig.routes.menuItems = sortMenuItemsByOrdem([
        {
          idMenu: "home",
          descricao: "Home",
          ordem: 0,
          icone: "home",
          rota: "/home",
          subMenus: null,
          componente: null,
          tipo: "item",
          menuAcima: 0,
        },
        ...action.payload.acessosUser,
        {
          idMenu: "faq",
          descricao: "FAQ",
          ordem: 9998,
          icone: "help",
          rota: "/faq",
          subMenus: null,
          componente: null,
          tipo: "item",
          menuAcima: 0,
        },
        {
          idMenu: "logout",
          descricao: "Sair",
          ordem: 9999,
          icone: "exit_to_app",
          rota: "#",
          subMenus: null,
          componente: null,
          tipo: "item",
          menuAcima: 0,
        },
      ]);
      state.userConfig.listaTransportadoras =
        action.payload?.apelidoTransportadora ?? [];
      state.userConfig.routes.renderItems = generateRoutes(
        formatArrayAccessUser(action.payload?.acessosUser ?? [])
      );
      state.userConfig.routes.allowedRoutes = verifyAllowedUserAccess(
        action.payload?.acessosUser ?? []
      );
      state.userConfig.isJuridico = action.payload.isJuridico;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getUserSetup.fulfilled, dataUserSetupReducer);
  },
});

export const { setUserConfig } = userSetupSlice.actions;

export default userSetupSlice.reducer;
